import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '@utils/api'
import type { AlertResponse } from './AlertsDisplay/types'
import type { AxiosResponse } from 'axios'

export function useSiteAlerts() {
  const queryClient = useQueryClient()

  const alertsQuery = useQuery<AxiosResponse<AlertResponse>>({
    queryKey: ['siteAlerts'],
    queryFn: () => api.getAlerts(),
    refetchInterval: 60_000, // Refetch every minute
  })

  const { mutateAsync: handleResolveAlert } = useMutation({
    mutationFn: (alertId: string) => api.resolveAlert(alertId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['siteAlerts'] })
    },
    onError: (error) => {
      console.error('Failed to resolve alert:', error)
    },
  })

  return { siteAlertsResponse: alertsQuery.data?.data, handleResolveAlert }
}
